var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { removeClass, addClass, getParentWithClass } from '@/support/Html';
import { excludeRoles } from '@/support/ExcludeRoles';
import { Student } from '@/models/Student';
let SubjectUser = class SubjectUser extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    openTreatmentDialog() {
        this.$emit('openTreatmentDialog', this.user.id);
    }
    toggleUserMenu(event) {
        const target = event.target;
        const activeMenu = target.querySelectorAll('.user-menu--show')[0];
        if (activeMenu) {
            removeClass(activeMenu, 'user-menu--show');
            // Z-INDEX WEG
            const parent = getParentWithClass(activeMenu, 'subject-user-cell--active');
            if (parent) {
                parent.classList.remove('subject-user-cell--active');
            }
        }
        else {
            const activeButton = document.querySelectorAll('.user-menu--show')[0];
            if (activeButton) {
                removeClass(activeButton, 'user-menu--show');
                // Z-INDEX WEG
                const element = document.querySelector('.subject-user-cell--active');
                if (element) {
                    element.classList.remove('subject-user-cell--active');
                }
            }
            const menu = target.querySelectorAll('.user-menu')[0];
            addClass(menu, 'user-menu--show');
            const parent = getParentWithClass(target, 'subject-user-cell');
            if (parent) {
                parent.classList.add('subject-user-cell--active');
            }
        }
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only
    // #endregion
    // #region Getters & Setters
    get isAdminRole() {
        return this.$store.state.Auth.hasRole(['teacher', 'administrator', 'root']);
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], SubjectUser.prototype, "user", void 0);
SubjectUser = __decorate([
    Component({})
], SubjectUser);
export default SubjectUser;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
